import { useEffect, useState } from 'react';
import { onSnapshot, collection, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { sortNotificationsByDate, getSentTo, sortNotificationsByDate2 } from '../shared/helpers';

export default function useNotifications(userData, requestsList) {
    const [activeNotifications, setActiveNotifications] = useState([]);

    useEffect(() => {
        if (!userData || !userData.dimension) {
            setActiveNotifications([]);
            return;
        };

        let q;
        let unsub;

        // ESTABLECIMIENTO
        if (userData && userData.dimension === 'Establecimiento') {
            q = query(
                collection(db, 'notifications'),
                where('establishmentId', '==', userData.establishmentId),
                where('seenBy', '==', null)
            );

            unsub = onSnapshot(q, (querySnapshot) => {
                const data = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                if (data.length > 0) {
                    setActiveNotifications(sortNotificationsByDate(data));
                } else {
                    setActiveNotifications([]);
                }
            });
        }

        // SOSTENEDOR
        else if (userData && userData.dimension === 'Sostenedor') {
            const filteredNotifications = requestsList.filter(request =>
                getSentTo(request) === userData.department)
                .filter(request => request.idProject === userData.tenantId);

            if (filteredNotifications.length > 0) {
                const sortedNotifications = sortNotificationsByDate2(filteredNotifications);
                setActiveNotifications(sortedNotifications);
            } else {
                setActiveNotifications([]);
            }

        }

        return () => unsub && unsub();
    }, [userData]);

    return { activeNotifications };
};